export default __webpack_public_path__ + "static/media/Mark-3-HUD-Targeting (TD).d6ce7567.jpg";